// extracted by mini-css-extract-plugin
export default {"grayColor":"#a2a2a8"};